module.exports = __webpack_public_path__ + "static/media/loading.0cd50330.svg";